import React from 'react';

const QuestionCard = ({ eyebrow, title, description, children }) => (
  <section className="question-card">
    {eyebrow && <p className="question-card__eyebrow">{eyebrow.toUpperCase()}</p>}
    <h1>{title}</h1>
    {description && <p className="question-card__lede">{description}</p>}
    <div className="question-card__content">{children}</div>
  </section>
);

export default QuestionCard;
